export const CABINET_TYPES = [
  ["base", "Base"], ["upper", "Upper"], ["tall", "Tall"], ["drawer_bank", "Drawer Bank"],
];

export const money = value => Number(value || 0).toLocaleString("en-CA", {
  style: "currency", currency: "CAD", minimumFractionDigits: 2,
});

export const calculateWizardPricing = wizard => {
  const rates = wizard?.linear_foot_rates || {};
  const cabinetLines = (wizard?.cabinets || []).map(row => {
    const linearFeet = Number(row.width || 0) * Number(row.quantity || 1) / 12;
    const rate = Number(rates[row.cabinet_type] || 0);
    return { ...row, linear_feet: linearFeet, rate_per_linear_foot: rate, line_total: linearFeet * rate };
  });
  const cabinetsSubtotal = cabinetLines.reduce((sum, row) => sum + row.line_total, 0);
  const upgrades = (wizard?.wishlist || []).filter(row => row.selected);
  const upgradesSubtotal = upgrades.reduce((sum, row) => sum + Number(row.price_adder || 0), 0);
  const suggestedInstallation = (cabinetsSubtotal + upgradesSubtotal) * Number(wizard?.installation_percentage || 0) / 100;
  const installationTotal = wizard?.project_type === "supply_only" ? 0
    : wizard?.manual_installation_total !== null && wizard?.manual_installation_total !== undefined && wizard?.manual_installation_total !== ""
      ? Number(wizard.manual_installation_total) : suggestedInstallation;
  const subtotal = cabinetsSubtotal + upgradesSubtotal + installationTotal;
  const taxAmount = subtotal * Number(wizard?.tax_rate || 0) / 100;
  const total = subtotal + taxAmount;
  const percentages = wizard?.project_type === "supply_only" ? [50, 50] : [50, 40, 10];
  const labels = wizard?.project_type === "supply_only"
    ? ["Retainer Deposit", "Pre-Delivery Payment"]
    : ["Retainer Deposit", "Pre-Delivery / Production Completion", "Final Install Sign-Off"];
  return {
    cabinetLines, cabinetsSubtotal, upgrades, upgradesSubtotal, suggestedInstallation,
    installationTotal, subtotal, taxAmount, total,
    milestones: percentages.map((percentage, index) => ({ label: labels[index], percentage, amount: total * percentage / 100 })),
  };
};